import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import ProductPage from './components/ProductPage';
import Login from './pages/Login';
import Cadastro from './pages/Cadastro';
import ComoFunciona from './pages/ComoFunciona';
import Contato from './pages/Contato';
import FAQ from './pages/FAQ';
import Termos from './pages/Termos';
import Regras from './pages/Regras';
import Privacidade from './pages/Privacidade';
import RecuperarSenha from './pages/RecuperarSenha';
import ResetPassword from './pages/ResetPassword';
import SubaDeNivel from './pages/SubaDeNivel';
import Dashboard from './pages/Dashboard';
import Configuracoes from './pages/Configuracoes';
import Usuarios from './pages/Usuarios';
import Categorias from './pages/Categorias';
import Produtos from './pages/Produtos';
import Leiloes from './pages/Leiloes';
import PublicAuctions from './pages/PublicAuctions';
import DashboardAdminMarcas from './pages/DashboardAdminMarcas';
import DashboardAdminModelos from './pages/DashboardAdminModelos';
import {
  DashboardAdminLances,
  DashboardAdminCashback,
  DashboardAdminTransacoes,
  DashboardAdminRelatorios,
  DashboardAdminContatos
} from './pages/DashboardAdminPages';
import {
  DashboardUsuarioMinhaConta,
  DashboardUsuarioMeusLances,
  DashboardUsuarioMeuCashback,
  DashboardUsuarioMeusFavoritos
} from './pages/DashboardUsuarioPages';

import GetcoinMarketplace from './pages/GetcoinMarketplace';

import Manual from './pages/Manual';
import Paginas from './pages/Paginas';
import CustomPage from './pages/CustomPage';
import Logs from './pages/Logs';

function App() {
  const [searchTerm, setSearchTerm] = React.useState('');

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <div className="App">
          <Routes>
            {/* Rotas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/recuperar-senha" element={<RecuperarSenha />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Rota Unificada do Dashboard */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />

            {/* Sub-rotas do Dashboard (Admin) */}
            <Route path="/dashboard/usuarios" element={
              <ProtectedRoute adminOnly={true}>
                <Usuarios />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/categorias" element={
              <ProtectedRoute adminOnly={true}>
                <Categorias />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/marcas" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminMarcas />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/modelos" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminModelos />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/produtos" element={
              <ProtectedRoute adminOnly={true}>
                <Produtos />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/leiloes" element={
              <ProtectedRoute adminOnly={true}>
                <Leiloes />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/lances" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminLances />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/cashback" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminCashback />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/transacoes" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminTransacoes />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/relatorios" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminRelatorios />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/contatos" element={
              <ProtectedRoute adminOnly={true}>
                <DashboardAdminContatos />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/paginas" element={
              <ProtectedRoute adminOnly={true}>
                <Paginas />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/logs" element={
              <ProtectedRoute adminOnly={true}>
                <Logs />
              </ProtectedRoute>
            } />
            
            {/* Rotas de Configurações */}
            <Route path="/dashboard/configuracoes" element={<Navigate to="/dashboard/configuracoes/layout" replace />} />
            <Route path="/dashboard/configuracoes/layout" element={
              <ProtectedRoute adminOnly={true}>
                <Configuracoes />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/configuracoes/textos" element={
              <ProtectedRoute adminOnly={true}>
                <Configuracoes />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/configuracoes/traducoes" element={
              <ProtectedRoute adminOnly={true}>
                <Configuracoes />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/configuracoes/sistema" element={
              <ProtectedRoute adminOnly={true}>
                <Configuracoes />
              </ProtectedRoute>
            } />
            
            {/* Sub-rotas do Dashboard (Usuário) */}
            <Route path="/dashboard/minha-conta" element={
              <ProtectedRoute>
                <DashboardUsuarioMinhaConta />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/meus-lances" element={
              <ProtectedRoute>
                <DashboardUsuarioMeusLances />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/meu-cashback" element={
              <ProtectedRoute>
                <DashboardUsuarioMeuCashback />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/getcoin-marketplace" element={
              <ProtectedRoute>
                <GetcoinMarketplace />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/meus-favoritos" element={
              <ProtectedRoute>
                <DashboardUsuarioMeusFavoritos />
              </ProtectedRoute>
            } />
            
            {/* Rotas públicas */}
            <Route path="/" element={<Layout onSearch={handleSearch}><HomePage searchTerm={searchTerm} onSearch={handleSearch} /></Layout>} />
            <Route path="/leiloes" element={<Layout onSearch={handleSearch}><PublicAuctions searchTerm={searchTerm} /></Layout>} />
            <Route path="/produto/:slug" element={<Layout onSearch={handleSearch}><ProductPage /></Layout>} />
            <Route path="/suba-de-nivel" element={<Layout onSearch={handleSearch}><SubaDeNivel /></Layout>} />
            <Route path="/como-funciona" element={<Layout onSearch={handleSearch}><ComoFunciona /></Layout>} />
            <Route path="/contato" element={<Layout onSearch={handleSearch}><Contato /></Layout>} />
            <Route path="/faq" element={<Layout onSearch={handleSearch}><FAQ /></Layout>} />
            <Route path="/termos" element={<Layout onSearch={handleSearch}><Termos /></Layout>} />
            <Route path="/privacidade" element={<Layout onSearch={handleSearch}><Privacidade /></Layout>} />
            <Route path="/regras" element={<Layout onSearch={handleSearch}><Regras /></Layout>} />
            <Route path="/manual" element={<Layout onSearch={handleSearch}><Manual /></Layout>} />
            <Route path="/p/:slug" element={<Layout onSearch={handleSearch}><CustomPage /></Layout>} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
    </ThemeProvider>
  );
}

export default App;
